export const roles = {
	SUPER_ADMIN: 0,
	ADMIN: 1,
	MEMBER: 2,
	AUTHENTICATED_GUEST: 3,
};
